$(document).ready(function () {
  checkBackToTop('#products-list', '#filters');


  // ======== Form inputs validation ========
  $('.form-control[required]').not('.ignore').keyup(function () {
    if ((this.validity.typeMismatch === true || this.validity.patternMismatch === true) && this.validity.valid === false) {
      if (this.type == 'email') {
        this.setCustomValidity('Въведете правилен Email!');
      }
      return
    }
    if (this.validity.valid !== false || this.value != '') {
      this.setCustomValidity('')
    } else {
      this.setCustomValidity('Полето е задължително!');
    }
  })
  $('.form-control[required]').not('.ignore').each(function () {
    if (this.validity.valid === false) {
      this.setCustomValidity('Полето е задължително!');
    }
  })


  $('#categories .nav .dropdown').hover(
    function() {
      if ($(window).width() >= 992) {
        $('#categories').css('z-index', '1000')
        $(this).find('.dropdown-menu').stop().fadeIn('fast');
        $('.overlay').stop().fadeIn('10');
      }
    },
    function() {
      if ($(window).width() >= 992) {
        $('#categories').css('z-index', '')
        $(this).find('.dropdown-menu').stop().hide();
        $('.overlay').stop().hide();
      }
    }
  );




  if (checkIfExists('header #categories')) {

    let nav_width = $('header #categories').width();

      $('#navigation-toggle').sidr({
        name: 'sidr-main',
        source: '#categories',
        renaming: false,
        displace: false,
        onOpen: function () {
          $('.overlay').css('z-index', '1030');
          $('.overlay').fadeIn('fast');
        },
        onClose: function () {
          $('.overlay').fadeOut('fast');
          $('.overlay').css('z-index', '');
        }
      });

      $('#sidr-main .dropdown-toggle').on('click', function(e){
        e.preventDefault();
        $('#sidr-main .dropdown-toggle').not(this).removeClass('dropdown-show');
        $(this).toggleClass('dropdown-show').next().slideToggle('fast');
        // $('#sidr-main .dropdown-toggle').not('.dropdown-show').next().slideUp('fast');

        $('#sidr-main .dropdown-toggle .fas').addClass('fa-angle-down').removeClass('fa-angle-up');
        // $('#sidr-main .dropdown-toggle.dropdown-show .fas').removeClass('fa-angle-down').addClass('fa-angle-up');
      });

      $('.close-sidr').on('click', function(){
        $.sidr('close', 'sidr-main');
        $.sidr('close', 'sidr-filter');
      });

    }

    $(document).on('change', '#close_check', function(e){
      var close_check = $('#close_check:checked').length;
      if (close_check == 1) {
        $('.btn-close').removeClass('disabled').removeAttr('disabled');
      }else{
        $('.btn-close').addClass('disabled').attr('disabled', 'disabled');
      }
    });

  });


  $('.overlay, .close-cart, .close-filter').click(function (e) {
    e.preventDefault();
    removeOpenedWindows();
  })


  $('.quick-cart, .mobile-cart-btn').on('click', function(e){
    e.preventDefault();
    $('.quick-cart-items').addClass('cart-active');
    $('.overlay').css('z-index', '1030');
    $('.overlay').fadeIn('fast');
    $('html, body').addClass('overflow-hidden');
  });




  var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy",
    load_delay: 300 //adjust according to use case
  });


  $(function () {
  $('[data-toggle="tooltip"]').tooltip()
})


$('.content-wrapper table').addClass('table table-striped table-bordered');
